import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { updateSection } from "../../../../../features/assignment/assignmentSlice";

import { getContentHeight } from "../../../../../utils/textUtils";
import { getStartingIndex } from "../../../../../utils/resumeUtils";

import SentenceReorder from "./SentenceReorder";
import CorrectOverlay from "../../widgets/CorrectOverlay";
import ArrowButton from "../../widgets/ArrowButton";
import StepsBar from "../../widgets/StepsBar";

const FlowPage = ({ setCurrentStep, isPreview, isReview }) => {
  const dispatch = useDispatch();

  const { section } = useSelector((state) => state.assignment);

  const [pageList, setPageList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isIncorrectOverlayVisible, setIsIncorrectOverlayVisible] =
    useState(false);

  const currentPage = pageList[currentIndex] || {
    type: "",
    data: {
      question_text: "",
      question: [],
      answer: [],
      input: [],
    },
  };

  useEffect(() => {
    if (pageList.length > 0) return;

    if (!isPreview && section.answer.length > 0) {
      setPageList(section.answer);
      setCurrentIndex(getStartingIndex(section.resumeIndex));
      return;
    }

    const tempPageList = [];
    const typeData = section.question.type_data;

    if (typeData) {
      if (typeData.kor) {
        const answer = section.question.data
          .slice(1)
          .map((sentence) => sentence[1]);
        tempPageList.push({
          type: "flow",
          data: {
            question_text: section.question.data[0][1],
            question: answer.slice().sort(() => Math.random() - 0.5),
            answer: answer,
            input: [],
          },
          isSubmitted: false,
        });
      }
      if (typeData.eng) {
        const answer = section.question.data
          .slice(1)
          .map((sentence) => sentence[0]);
        tempPageList.push({
          type: "flow",
          data: {
            question_text: section.question.data[0][0],
            question: answer.slice().sort(() => Math.random() - 0.5),
            answer: answer,
            input: [],
          },
          isSubmitted: false,
        });
      }
    } else {
      for (let i = 0; i < 2; i++) {
        const answer = section.question.data
          .slice(1)
          .map((sentence) => sentence[i ^ 1]);
        tempPageList.push({
          type: "flow",
          data: {
            question_text: section.question.data[0][i ^ 1],
            question: answer.slice().sort(() => Math.random() - 0.5),
            answer: answer,
            input: [],
          },
          isSubmitted: false,
        });
      }
    }
    setPageList(tempPageList);
  }, [section]);

  const handleNext = async () => {
    if (currentIndex === 0) {
      setCurrentIndex(1);
      setIsIncorrectOverlayVisible(false);
    } else if (currentIndex === 1) {
      if (!isPreview && !isReview) {
        dispatch(
          updateSection({
            sectionId: section.id,
            data: { is_finished: true, answer: pageList },
          })
        );
      }
      alert("학습이 완료되었습니다.");
      setCurrentStep(2);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: getContentHeight(),
        fontFamily:
          "'Pretendard','Spoqa Han Sans Neo','Apple SD Gothic Neo','Noto Sans KR',sans-serif",
        backgroundColor: "#FFFFFF",
      }}
    >
      {/* ECHO — 단계 표시줄. 내부 드래그 UI는 시안 05 명세("현재 UI 유지")대로 미변경 */}
      <StepsBar />

      {/* 삽화는 넣지 않는다(2026-09-28 사장님 결정). 8/19 에 "그림이 곧 실마리" 라며
          넣었다가 뺐다. 삽화는 핵심정리와 직독직해에만 둔다. */}
      {currentPage.type === "flow" && (
        <>
          <div
            style={{
              opacity: isIncorrectOverlayVisible ? 1 : 0, // Fade-in/out
              visibility: isIncorrectOverlayVisible ? "visible" : "hidden", // DOM에서 숨김
              transition: "opacity 200ms ease-out, visibility 200ms",
            }}
          >
            <CorrectOverlay bool={currentPage.isSubmitted} />
          </div>
          <SentenceReorder
            currentPage={currentPage}
            currentIndex={currentIndex}
            pageList={pageList}
            section={section}
            setPageList={setPageList}
            setIsIncorrectOverlayVisible={setIsIncorrectOverlayVisible}
          />
        </>
      )}
      {/* 화살표 버튼 (화면 오른쪽 중앙 고정) */}
      <div
        style={{
          position: "fixed",
          // [흰 네모 수술] 흰 배경+padding 15px 고정 버튼이 폰에서 카드 위에
          // 정체불명 흰 사각형으로 떠 보였음 → 폰은 투명 배경 + 가장자리 축소
          right: Math.min(window.innerWidth, window.screen.width) <= 768 ? "2px" : "60px",
          top: "50%",
          transform: "translateY(-50%)",
          border: "none",
          backgroundColor: Math.min(window.innerWidth, window.screen.width) <= 768 ? "transparent" : "#FFF",
          color: "#BEBEBE",
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: Math.min(window.innerWidth, window.screen.width) <= 768 ? "6px" : "15px",
        }}
      >
        <ArrowButton
          direction="right"
          onClick={() => handleNext()}
          visibleCondition={currentPage.isSubmitted === true}
        />
      </div>
    </div>
  );
};

export default FlowPage;
